import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CurrencyHelper } from '../helpers/currency.helper';

@Pipe({ name: 'agCurrency' })
export class CurrencyPipe implements PipeTransform {
  transform(
    value: any,
    currencyCode: string,
    _display: string | boolean = 'symbol',
    digitsInfo?: string,
    locale = 'en-US',
  ): any {
    if (!value) {
      return null;
    }

    let result = value;
    if (digitsInfo) {
      result = new DecimalPipe(locale).transform(value, digitsInfo);
    }

    let symbol = CurrencyHelper.getSymbol(currencyCode);
    if (!symbol) {
      symbol = currencyCode;
    }

    return `${symbol}${result}`;
  }
}
